"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const Loader_1 = __importDefault(require("../loader/Loader"));
const styled_components_1 = __importDefault(require("styled-components"));
const uuid_1 = require("uuid");
require("./baseButton.scss");
const BaseIcon_1 = __importDefault(require("../baseIcon/BaseIcon"));
const master_1 = require("../../constants/master");
const Notification_1 = __importDefault(require("../notification/Notification"));
const ConditionalTooltipWrapper_1 = __importDefault(require("../../components/common/conditionalTooltipWrapper/ConditionalTooltipWrapper"));
const StyledButton = styled_components_1.default.div `
  .loader {
    z-index: 99;
    position: absolute;
    top: 0;
    left: ${(p) => p.width * 0.5 - p.height * 0.5}px;
  }

  .primary,
  .secondary,
  .tertiary,
  .success,
  .danger {
    ${(p) => p.hoverDisabled
    ? `
        &::after, &::before {
            content: none !important;
        }
        `
    : `
                &::after {
            width: ${p.width}px !important;
            height: ${p.width}px !important;
            transform: translate(
                    ${`-${p.width / 2}px, -${p.width / 2}px`}
                )
                scale(0.1);
        }
        &:hover::after {
            transform-origin: center center !important;
            transform: scale(1)
                translate(${`-${p.width / 2}px, -${p.width / 2}px`}) !important;
        }`}
  }
  ${(p) => p.primaryColor
    ? `
		.customizable-icon {
			fill: ${p.primaryColor} !important;
			stroke: ${p.primaryColor} !important;
		}

    .customizable-icon .injected-svg {
      fill: ${p.primaryColor} !important;
      stroke: none !important;
    }

		.primary:not(.branding-disabled) {
			background-color: ${p.primaryColor};
			&::after {
				background-color: rgba(255,255,255,0.5);
			}
		}
		.secondary:not(.branding-disabled) {
			border-color: ${p.primaryColor} !important;
			color: ${p.primaryColor};
			p,
			span,
			a {
				color: ${p.primaryColor};
			}
			svg {
				color: ${p.primaryColor};
			}
			&::after {
				background-color: ${p.hoverColor};
			}
		}`
    : ``}

  .disabled {
    border-color: #8f8f8f !important;
    border: 2px solid #8f8f8f !important;

    .customizable-icon {
      fill: #8f8f8f !important;
      stroke: #8f8f8f !important;
    }

    .customizable-icon .injected-svg {
      fill: #8f8f8f !important;
      stroke: none !important;
    }

    &.primary:not(.branding-disabled) {
      background-color: #8f8f8f !important;
    }

    &.secondary:not(.branding-disabled) {
      border-color: #8f8f8f !important;
      color: #8f8f8f !important;
      p,
      span,
      a {
        color: #8f8f8f !important;
      }
      svg {
        color: #8f8f8f !important;
      }
    }
  }
`;
function Button(props) {
    var _a;
    const masterConfig = (0, master_1.getMasterConfig)();
    const [isHover, setIsHover] = (0, react_1.useState)(false);
    const [width, setWidth] = (0, react_1.useState)(0);
    const [innerWidth, setInnerWidth] = (0, react_1.useState)(0);
    const [height, setHeight] = (0, react_1.useState)(0);
    const buttonRef = (0, react_1.useRef)(null);
    const buttonInnerRef = (0, react_1.useRef)(null);
    const [id] = (0, react_1.useState)((0, uuid_1.v4)());
    const triggerOnCLick = (event) => {
        if (props.onClickAction && !props.disabled) {
            props.onClickAction(event);
        }
    };
    const getTextStyle = () => {
        switch (props.size) {
            case "large":
                return "s5";
            case "small":
                return "s7";
            default:
                return "s6";
        }
    };
    const getHoverColor = (color) => {
        let rgb = color.charAt(0) === "#" ? hexToRgb(color) : color;
        const rgbArray = rgb.split("(")[1].split(")")[0].split(",");
        const rgba = `rgba(${rgbArray[0]},${rgbArray[1]},${rgbArray[2]},0.2)`;
        return rgba;
    };
    const hexToRgb = (hex) => {
        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        const r = parseInt(result[1], 16);
        const g = parseInt(result[2], 16);
        const b = parseInt(result[3], 16);
        return result ? `rgb(${r},${g},${b})` : null;
    };
    function wrapperOnClick() {
        // Only works on mobile and when the button is disabled
        if (props.disabled &&
            props.disabledButtonTooltipOptions &&
            props.disabledButtonTooltipOptions.showNotificationInsteadTooltip) {
            (0, Notification_1.default)({
                type: props.disabledButtonTooltipOptions.tooltipType,
                text: props.disabledButtonTooltipOptions.text,
            });
            return;
        }
    }
    (0, react_1.useLayoutEffect)(() => {
        /**
         * Updates the dimensions of the button and inner content.
         */
        const updateDimensions = () => {
            if (buttonRef.current) {
                setWidth(buttonRef.current.offsetWidth);
                setHeight(buttonRef.current.offsetHeight);
            }
            if (buttonInnerRef.current) {
                setInnerWidth(buttonInnerRef.current.offsetWidth);
            }
        };
        //This function is called after a delay of 0 milliseconds, which effectively schedules it to run after the browser has finished rendering and updating the screen.
        // Delay the update to give the button time to finish rendering
        const timeoutId = setTimeout(updateDimensions, 0);
        // Clean up the timeout when the component unmounts
        return () => clearTimeout(timeoutId);
    }, [buttonRef.current, buttonInnerRef.current, id]);
    return (react_1.default.createElement(StyledButton, { width: width, height: height, primaryColor: props.backgroundColor || props.primaryColor || masterConfig.primaryColor, hoverColor: getHoverColor(props.backgroundColor || props.primaryColor || masterConfig.primaryColor), hoverDisabled: props.hoverDisabled ? true : false },
        react_1.default.createElement(ConditionalTooltipWrapper_1.default, { enableTooltip: (props.disabled &&
                props.disabledButtonTooltipOptions &&
                !props.disabledButtonTooltipOptions
                    .showNotificationInsteadTooltip) ||
                false, tooltipOptions: {
                content: (_a = props.disabledButtonTooltipOptions) === null || _a === void 0 ? void 0 : _a.text,
                place: "top",
            }, children: react_1.default.createElement("div", { ref: props.ref, onClick: wrapperOnClick, className: "button-wrapper", id: id },
                props.loading && (react_1.default.createElement(Loader_1.default, { type: props.type === "primary" ? "secondary" : "primary", height: height, width: width, className: "loader", styles: Object.assign({}, props.loadingSpinnerStyles) })),
                react_1.default.createElement("div", { onClick: triggerOnCLick, ref: buttonRef, onMouseEnter: () => {
                        setIsHover(true);
                    }, onMouseLeave: () => {
                        setIsHover(false);
                    }, className: `base-button flex-row jc-c ${props.type} ${props.size} ${props.className ? props.className : ""} ${getTextStyle()}
           ${props.disabled ? "disabled" : ""}`, style: Object.assign({ width: props.width && innerWidth > props.width
                            ? `fit-content`
                            : `${props.width}px`, minWidth: props.width && innerWidth > props.width
                            ? `fit-content`
                            : `${props.width}px`, maxWidth: props.width && innerWidth > props.width
                            ? `fit-content`
                            : `${props.width}px`, minHeight: `${props.height}px`, maxHeight: `${props.height}px`, opacity: props.loading ? "0.4" : "1" }, props.styles) },
                    react_1.default.createElement("div", { ref: buttonInnerRef, className: "button-inner" },
                        props.prefixIcon && (react_1.default.createElement(BaseIcon_1.default, { icon: props.prefixIcon, styles: {
                                marginRight: "10px",
                            } })),
                        props.children,
                        props.suffixIcon && (react_1.default.createElement(BaseIcon_1.default, { icon: props.suffixIcon, styles: {
                                marginLeft: "10px",
                            } }))))) })));
}
exports.default = Button;
